import { render, staticRenderFns } from "./NoBookingPopUp.vue?vue&type=template&id=f55022bc&scoped=true"
import script from "./NoBookingPopUp.vue?vue&type=script&lang=ts"
export * from "./NoBookingPopUp.vue?vue&type=script&lang=ts"
import style0 from "./NoBookingPopUp.vue?vue&type=style&index=0&id=f55022bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55022bc",
  null
  
)

export default component.exports